module.exports = __webpack_public_path__ + "img/icon-stock.9d1e2414.png";